module.exports = __webpack_public_path__ + "img/ic-nav-tuktuk--next--grey.32cce14c.svg";